var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverjoyed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 345.1 345.1",
    style: {
      enableBackground: "new 0 0 345.1 345.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2D243;}\n\t.st1{fill:#794A12;}\n\t.st2{fill:#975C1A;}\n\t.st3{fill:#FAF7F7;}\n\t.st4{fill:none;stroke:#794A12;stroke-width:5.3868;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 172.5,
    cy: 172.5,
    r: 172.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 119.6,
    cy: 145.7,
    rx: 22.3,
    ry: 26.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 225.5,
    cy: 145.7,
    rx: 22.3,
    ry: 26.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.5,239.8c17.3,41.3,57.9,68.2,102.3,68c45.8-0.2,87.1-29.1,103.1-72.4C208.5,236.9,140,238.4,71.5,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.5,200.3c28.3,8.4,68.3,17,116.6,17.3c44.1,0.2,81.1-6.6,108.2-13.7c-3.7,12.5-7.4,25.1-11.1,37.6 c-22.2,7.7-56,16.4-97.8,16.6c-45.6,0.2-82-10-105-18.3C67.9,226.7,64.2,213.5,60.5,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.7,199.4c28.2,8.7,68.5,17.8,117.4,18.2c44.2,0.3,81.3-6.5,108.2-13.7c-7.2,54.6-48.5,96.8-97.1,103.1 C129,314.8,67.8,268.2,59.7,199.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverjoyed);
export default __webpack_public_path__ + "static/media/overjoyed.71f17d62aa8c7c0eb0d4192078e556c4.svg";
export { ForwardRef as ReactComponent };